import React, { useEffect } from "react";
import { useRef } from "react";
// import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetOrganizationData } from "../../api/Actions/ServiceOrganization";
import { BeatLoader } from "react-spinners";
import toast, { Toaster } from "react-hot-toast";
const Home = () => {
  const dispatch = useDispatch();
  let DoCheckOrganization = useRef(true);

  // const [LoadingOrg, setLoadingOrg] = useState(false);

  const OrgData = useSelector(
    (state) => state.Organization.GetOrganizationData
  );

  const CopyUrl = (data) => {
    navigator.clipboard.writeText(data);
    toast("Copied");
  };

  // useEffect(() => {
  //   // loading data org
  //   setLoadingOrg(false);
  // }, [OrgData]);

  useEffect(() => {
    // check organization

    if (localStorage.getItem("orgUuid")) {
      console.log("check organization");
      dispatch(GetOrganizationData(localStorage.getItem("orgUuid")));
      // setLoadingOrg(true);
    }
  }, []);

  return (
    <div className="flex flex-col w-full h-screen px-4">
      <Toaster
        position="center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },

          // Default options for specific types
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
      <div className="h-20">{/* header section */}</div>
      <div className="flex flex-col mt-4 shadow-inner  bg-slate-100 rounded-xl h-full w-full">
        {OrgData ? (
          <div className="my-auto mx-auto">
            <div className="text-center">
              <h1 className="poppins-500 text-[15px] sm:text-sm">
                Welcome Back !
              </h1>
            </div>
            <div className="text-center p-5 tooltip text-white rounded-3xl bg-main-blue my-4">
              <p
                onClick={() => CopyUrl(OrgData.orgUuid)}
                className="poppins-500 text-[10px] sm:text-sm hover:text-red-500"
              >
                {OrgData.orgUuid}
              </p>
            </div>
            <div className="text-center">
              <p className="poppins-500 text-[15px] sm:text-sm">
                {OrgData.name}
              </p>
            </div>
          </div>
        ) : (
          <div className="mx-auto my-auto">
            <BeatLoader className="my-auto" color="#075985" size={8} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
